import React, { useEffect, useState } from 'react';
import './ScrollArrow.css'; // Import styles for the arrow

const ScrollArrow = () => {
  const [isVisible, setIsVisible] = useState(false);

  const checkScroll = () => {
    // Show the arrow when the user scrolls down 100 pixels
    if (window.scrollY > 100) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', checkScroll);
    
    // Clean up the event listener
    return () => {
      window.removeEventListener('scroll', checkScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div
      className={`scroll-arrow ${isVisible ? 'visible' : ''}`}
      onClick={scrollToTop}
    >
      ↑
    </div>
  );
};

export default ScrollArrow;
